var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"pa-8",attrs:{"elevation":"5","rounded":""}},[_c('v-card-text',[_c('desks-table',{attrs:{"office-id":_vm.$route.params.officeId}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }